module.exports = __webpack_public_path__ + "static/media/topImage.b7e65d8f.jpg";